const resource = '/v1/documents';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.post(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  getMetaList() {
    return $axios.get(`/v1/metas`);
  },

  getTypeByCategoryId(categoryIds = []) {
    categoryIds = categoryIds.join(',');
    return $axios.get(`/v1/types/${categoryIds}`);
  },

  getMetaCommon() {
    return $axios.get(`/v1/get-meta-common`);
  },

  uploadToTmpStorage(payload, configs) {
    return $axios.post(`${resource}/upload-to-tmp-storage`, payload, configs);
  },

  bulkUploadToTmpStorage(payload, configs) {
    return $axios.post(`${resource}/bulk-upload-to-tmp-storage`, payload, configs);
  },

  getBulkUploadDocumentFromRedis() {
    return $axios.get(`${resource}/get-bulk-upload-from-redis`);
  },

  findBulkUploadDocumentByIdFromRedis(key) {
    return $axios.get(`${resource}/find-bulk-upload-by-id-from-redis/${key}`);
  },

  updateBulkUploadById(payload, id) {
    return $axios.post(`${resource}/update-bulk-upload-by-id/${id}`, payload);
  },

  deleteBulkUploadByIdFromRedis(id) {
    return $axios.delete(`${resource}/delete-bulk-upload-by-id-from-redis/${id}`);
  },

  findDocumentByTmp(payload) {
    return $axios.get(`${resource}/${payload}`);
  },

  upload(payload, configs) {
    return $axios.post(`${resource}`, payload, configs);
  },

  saveDocumentAsDraft(payload, configs) {
    return $axios.post(`${resource}/save-as-draft`, payload, configs);
  },

  getDraftDocumentUpload() {
    return $axios.get(`${resource}/get-draft-document-upload`);
  },

  findDraftDocumentById(id) {
    return $axios.get(`${resource}/find-draft-document-by-id/${id}`);
  },

  deleteDraftDocumentById(id) {
    return $axios.delete(`${resource}/delete-draft-document-by-id/${id}`);
  },

  getDocumentData(payload) {
    return $axios.post(`${resource}/list-category`, payload);
  },

  getNodes(payload) {
    return $axios.post(`${resource}/get-nodes`, payload)
  },

  generateShareToken(payload) {
    return $axios.post(`${resource}/generate-share-token`, payload);
  },

  share(payload) {
    return $axios.post(`${resource}/shared`, payload);
  },

  findSharedDocument(token) {
    return $axios.get(`${resource}/shared/${token}`);
  },

  unlockPassword(payload) {
    return $axios.post(`${resource}/shared/unlock-password`, payload)
  },

  deleteDocuments(documentIds) {
    return $axios.delete(`${resource}/delete`, {
      data: {
        documentIds
      }
    })
  },

  findCommentsByDocumentId(documentId) {
    return $axios.get(`${resource}/comments/${documentId}`);
  },

  storeComment(payload) {
    return $axios.post(`${resource}/comments`, payload);
  },

  deleteComment(payload) {
    return $axios.delete(`${resource}/comments/${payload}`);
  },
  
  approveDocument(payload) {
    return $axios.post(`${resource}/approve/${payload.id}`, payload);
  },
  
  checkCanEdit(id) {
    return $axios.get(`${resource}/approve/check-edit/${id}`);
  },

  recentlyMeta(typeId) {
    return $axios.get(`${resource}/get-recently-meta/${typeId}`);
  },

  preview(versionId) {
    return $axios.get(`${resource}/preview/${versionId}`);
  },

  previewApproveFile(fileId) {
    return $axios.get(`${resource}/previewApproveFile/${fileId}`);
  },

  getDownloadHistory(id) {
    return $axios.get(`${resource}/${id}/downloads`);
  },

  getListMeApproveRequest() {
    return $axios.get(`${resource}/approve/list-me-request`);
  },

  getListApproveRequest() {
    return $axios.get(`${resource}/approve/list-request`);
  },

  getListDashboardApproveRequest() {
    return $axios.get(`${resource}/approve/dashboard-approve`);
  }

});
